export default "__VITE_ASSET__DYAcVFfM__"